import { useState } from 'react';
import { ChevronDown, ChevronUp, FileText, CheckCircle, UserPlus } from 'lucide-react';

export interface Activity {
  id: string;
  type:"contract_created"|"contract_signed_by_contractor"|"subcontractor_added"|"contract_signed_by_homeowner";
  description: string;
  time: string;
}

interface RecentActivityProps {
  activities?: Activity[];
}

export function RecentActivity({ activities }: RecentActivityProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const displayActivities = activities || [];
  const visibleActivities = isExpanded ? displayActivities : displayActivities.slice(0, 5);
  const hiddenCount = Math.max(displayActivities.length - visibleActivities.length, 0);

  const iconMap = {
    contract_created: <FileText className="w-4 h-4 text-gray-400" />,
    contract_signed_by_contractor : <CheckCircle className="w-4 h-4 text-gray-400" />,
    contract_signed_by_homeowner: <CheckCircle className="w-4 h-4 text-gray-400" />,
    subcontractor_added: <UserPlus className="w-4 h-4 text-gray-400" />
  };

  return (
    <section className="dashboard-panel activity-panel bg-white border border-gray-200 rounded-xl p-6 shadow-sm" aria-labelledby="recent-activity-title">
      <h3 id="recent-activity-title" className="font-[500] text-gray-900 mb-5 tracking-tight">Recent Activity</h3>
      <ul className="activity-panel__list space-y-2">
        {visibleActivities.map((activity) => (
          <li key={activity.id} className="activity-panel__item flex items-start gap-3.5 pb-4 border-b border-gray-100 last:border-0 last:pb-0">
            <div className="mt-0.5 p-2 bg-gray-50 rounded-lg">
              {iconMap[activity.type]}
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm text-gray-700 leading-relaxed">{activity.description}</div>
              <div className="text-xs text-gray-500 mt-1.5 font-medium">{activity.time}</div>
            </div>
          </li>
        ))}
      </ul>
      {displayActivities.length > 5 && (
        <button
          type="button"
          className="activity-panel__toggle"
          aria-expanded={isExpanded}
          onClick={() => setIsExpanded((value) => !value)}
        >
          {isExpanded ? <ChevronUp size={15} aria-hidden="true" /> : <ChevronDown size={15} aria-hidden="true" />}
          {isExpanded ? 'Show less' : `Show ${hiddenCount} more`}
        </button>
      )}
    </section>
  );
}
